export default "__VITE_ASSET__Cpq88tRw__"